export const dashboardMapperMethod = (dashboardName, dashboardData, gridItemConfig) => {

  let chartsModelList = [];
  let gridItemsList = [];

  const selectedItem = dashboardData.filter(item => item.name === dashboardName);
  if(selectedItem.length!==0){
    const selectedDashboard = selectedItem[0].dashboards;
    selectedDashboard.forEach((item) => {
      let chartModel = {
        key: item.key,
        x: item.x,
        y: item.y,
        w: item.w,
        h: item.h,
        minW: gridItemConfig.minW,
        minH: gridItemConfig.minH,
        chartType: item.chartType,
        dimensionType: item.dimensionType,
        machines: item.machines,
        property: item.property,
      };
      let gridModel = {
        key: item.key,
        x: item.x,
        y: item.y,
        w: item.w,
        h: item.h,
        minW: gridItemConfig.minW,
        minH: gridItemConfig.minH
      };
      chartsModelList.push(chartModel);
      gridItemsList.push(gridModel);
    });
  }
  return { chartsModelList, gridItemsList };
};
